import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Lightbulb, X } from "lucide-react";
import { useMode } from "@/context/ModeContext";
import { guideFor } from "@/lib/pageGuide";

// Beginner-mode banner at the top of every page: one-sentence "what is this page" + the most useful next step. Dismissible per page.
export const PageIntro = () => {
  const { beginner } = useMode();
  const { pathname } = useLocation();
  const g = guideFor(pathname);
  const key = `apx:intro-dismissed:${g ? pathname.split("/").slice(0, 2).join("/") : ""}`;
  const [hidden, setHidden] = useState(() => !!localStorage.getItem(key));
  if (!beginner || !g || hidden) return null;
  return (
    <div className="mx-4 md:mx-6 mt-4 rounded-xl border border-cyan-900/50 bg-cyan-500/5 px-4 py-3 flex items-start gap-3" data-testid="page-intro">
      <Lightbulb className="w-4 h-4 text-cyan-300 mt-0.5 shrink-0" />
      <div className="text-xs text-slate-300 leading-relaxed min-w-0">
        <strong className="text-slate-100">{g.title}:</strong> {g.intro} {g.next && <span className="text-slate-400">Next step: {g.next}</span>}{" "}
        <button data-testid="page-intro-explain" onClick={() => document.querySelector('[data-testid="explain-page-btn"]')?.click()} className="text-cyan-300 underline">Explain every section →</button>
      </div>
      <button aria-label="Dismiss" data-testid="page-intro-dismiss" onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }} className="btn-ghost rounded-md p-1 shrink-0"><X className="w-3.5 h-3.5 text-slate-500" /></button>
    </div>
  );
};
